import { render, staticRenderFns } from "./BlockSlideshow.vue?vue&type=template&id=166d6f18&scoped=true&"
import script from "./BlockSlideshow.vue?vue&type=script&lang=js&"
export * from "./BlockSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlideshow.vue?vue&type=style&index=0&id=166d6f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d6f18",
  null
  
)

export default component.exports